import React, { useEffect, useState } from 'react';

import dataMapper from '../../utils/dataMapper';

function CSVTextDisplay({ data, ...props }) {
  const [mappedData, setMappedData] = useState([]);

  useEffect(() => {
    if (props.columnsMappers) {
      setMappedData(dataMapper(data, props.columnsMappers));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      {mappedData.map((row, i) => {
        let values = Object.values(row).join(', ');
        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i} style={{ display: 'block' }}>
            {values}
          </span>
        );
      })}
    </div>
  );
}

export default CSVTextDisplay;
